import React, {useEffect, useRef } from 'react'
import { motion } from "framer-motion";
import "./announcement-bar.css";

const AnnouncementBar = () => {
  const ref = useRef(null);
  useEffect(() => {
    console.log("width", ref.current.offsetWidth);
  }, []);

  return (
    <div>
      <div className="announcement__marquee">
        <motion.div className="announcement__track" variants={marqueeVariants}
          animate="animate">
          <p ref={ref}>
            <span>ELEVATE YOUR BRAND</span>
            <span>SHINE LIKE THE BIG GUYS</span>
            <span>TELL YOUR STORY</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>SHINE LIKE THE BIG GUYS</span>
            <span>TELL YOUR STORY</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>SHINE LIKE THE BIG GUYS</span>
            <span>TELL YOUR STORY</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>SHINE LIKE THE BIG GUYS</span>
            <span>TELL YOUR STORY</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>SHINE LIKE THE BIG GUYS</span>
            <span>TELL YOUR STORY</span>
            {/* <span>ELEVATE YOUR BRAND</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>ELEVATE YOUR BRAND</span>
            <span>ELEVATE YOUR BRAND</span> */}
          </p>
        </motion.div>
      </div>
    </div>
  )
}

export default AnnouncementBar

const marqueeVariants = {
  animate: {
    // x: [0, -1035],
    x: [0, -1465.5],
    transition: {
      x: {
        repeat: Infinity,
        repeatType: "loop",
        duration: 25,
        ease: "linear",
      },
    },
  },
};